import { LockClosedIcon } from "@heroicons/react/solid";
import { useLogin } from "hooks/auth";
import { AlertError, Form } from "lib";
import { useTranslation } from "next-i18next";

import Logo from "./Logo";

function Login() {
  const { t } = useTranslation();
  const { mutateAsync, methods, error } = useLogin();

  return (
    <div className="flex min-h-screen flex-col py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <Logo className="mx-auto h-12 w-auto" />
        <h1 className="mt-6 text-center text-3xl font-extrabold leading-9 text-gray-900">
          WEB POS
        </h1>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white px-4 py-8 shadow sm:rounded-lg sm:px-10">
          <Form
            methods={methods}
            onSubmit={async (data) => {
              await mutateAsync(data).catch(() => null);
            }}
          >
            <Form.Email required name="username" />
            <Form.Password required wrapperClass="mt-6" />
            <AlertError className="mt-6">{error}</AlertError>
            <div className="mt-6">
              <Form.SubmitButton block className="relative">
                <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                  <LockClosedIcon className="h-5 w-5 text-primary-500 transition duration-150 ease-in-out group-hover:text-primary-400" />
                </span>
                {t("layout.login")}
              </Form.SubmitButton>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default Login;
